import _ from 'lodash';
import { VIDEO_APP_DEF_ID } from 'shared/constants/app-def-id';
import { ExternalPageId } from '@wix/business-manager-api';
import URL from 'shared/utils/url/index';


export function checkIsBusinessManager() {
  return !_.isEmpty(window.BusinessManagerAPI);
}

export function getVideoModule() {
  if (!checkIsBusinessManager()) {
    return null;
  }

  const { getModule, ModuleId } = window.BusinessManagerAPI;
  return getModule(ModuleId.Video);
}

export function getModuleParam(key) {
  const moduleParams = getVideoModule().getModuleParams();
  return moduleParams[key];
}

export function apllyBMOverrides(WixSDK) {
  const isBusinessManager = checkIsBusinessManager();

  if (!isBusinessManager) {
    return WixSDK;
  }

  return {
    Utils: {
      ...WixSDK.Utils,

      getInstance() {
        return getModuleParam('instance');
      },

      getInstanceId() {
        return getModuleParam('instanceId');
      },

      getInstanceValue(key) {
        if (key === 'appDefId') {
          return VIDEO_APP_DEF_ID;
        }

        if (key === 'uid') {
          return getModuleParam('userId');
        }

        return WixSDK.Utils.getInstanceValue(key);
      },

      getCompId() {
        return 1;
      },

      getOrigCompId() {
        return 1;
      },

      getLocale() {
        return getModuleParam('locale');
      },

      getSiteOwnerId() {
        return getModuleParam('userId');
      },

      getViewMode() {
        return getModuleParam('viewMode');
      },

      getUid() {
        return getModuleParam('userId');
      },
    },

    Styles: {
      ...WixSDK.Styles,

      getStyleParams() {
        // FIXME: replace with better way to work with style params when available
        return new Promise((resolve, reject) => {
          const viewMode = getModuleParam('viewMode');
          // onboarding view mode is for ADI
          if (viewMode !== 'editor' && viewMode !== 'onboarding') {
            return reject();
          }

          const messageListener = event => {
            if (!_.isString(event.data)) {
              return;
            }

            let data;

            try {
              data = JSON.parse(event.data);
            } catch (e) {
              return;
            }

            const { intent, type, res } = data;

            if (intent === 'TPA_RESPONSE' && type === 'appIsAlive') {
              resolve(res.style);
              window.removeEventListener('message', messageListener);
            }
          };

          window.addEventListener('message', messageListener);

          window.parent.postMessage(
            JSON.stringify({
              data: {},
              intent: 'TPA2',
              type: 'appIsAlive',
            }),
            '*'
          );
        });
      },

      setWidgetChannel(id) {
        window.parent.postMessage(
          JSON.stringify({
            data: {
              type: 'font',
              key: 'channelId',
              param: {
                value: id,
              },
            },
            intent: 'TPA2',
            namespace: 'Styles',
            type: 'setStyleParam',
          }),
          '*'
        );
      },
    },

    Settings: {
      ...WixSDK.Settings,

      getSiteInfo() {
        const editorUrl = new URL(getModuleParam('editUrl'));

        return Promise.resolve({
          url: getModuleParam('viewUrl'),
          referer: `${editorUrl.protocol}//${editorUrl.hostname}`,
        });
      },

      PremiumIntent: {
        NEUTRAL: 'NEUTRAL',
        FREE: 'FREE',
        PAID: 'PAID',
      },

      appEngaged(premiumIntent) {
        window.ModuleRegistry.invoke('businessManager.appEngaged', {
          premiumIntent,
          appDefinitionId: VIDEO_APP_DEF_ID,
        });
      },

      triggerSettingsUpdatedEvent(message) {
        // TODO: replace with what guys from BM are going to add to BusinessManagerAPI
        window.parent.postMessage(
          JSON.stringify({
            data: {
              compId: '*',
              message,
            },
            intent: 'TPA2',
            namespace: 'Settings',
            type: 'postMessage',
          }),
          '*'
        );
      },
    },

    SuperApps: {
      ...WixSDK.SuperApps,

      Settings: {
        ...WixSDK.SuperApps.Settings,

        openBillingPage({ referrer }) {
          window.ModuleRegistry.invoke('businessManager.navigateTo', {
            pageComponentId: ExternalPageId.PackagePicker,
            contextData: {
              appDefId: VIDEO_APP_DEF_ID,
              instanceId: getModuleParam('instanceId'),
              referrer,
            },
            openInNewTab: true,
          });
        },
      },
    },

    Dashboard: {
      ...WixSDK.Dashboard,

      setHelpArticle(articleId) {
        window.ModuleRegistry.invoke('businessManager.setHelpArticle', { articleId });
      },

      getEditorUrl() {
        return Promise.resolve(getModuleParam('editUrl'));
      },
    },

    getSiteUrl() {
      return Promise.resolve(getModuleParam('viewUrl'));
    },

    closeWindow() {
      // TODO: replace with what guys from BM are going to add to BusinessManagerAPI
      window.parent.postMessage(
        JSON.stringify({
          intent: 'TPA2',
          namespace: 'Wix',
          data: {},
          type: 'closeWindow',
        }),
        '*'
      );
    },
  };
}



// WEBPACK FOOTER //
// ./src/bm-integration/utils/business-manager-api.js